import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/Header";

const Layout = () => {
    return (
        <div className="min-h-screen flex flex-col">
            {/* Fixed Height Header */}
            <Header />

            {/* Content Area */}
            <main className="flex-1 overflow-hidden bg-purple-200">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 h-full">
                    <Outlet />
                </div>
            </main>
        </div>
    );
};

export default Layout;
